module.exports = __webpack_public_path__ + "static/img/home_type_icon_jbcx.4fd57622.webp";